'use strict';

/*global services*/
/*global isEmpty*/
/*global initialize*/
/*global replaceAttrKey*/
/*global parseFloatK2*/
/*global formatFloatK2*/
/*global roundToDecimals*/
function OrderConfirm(containerID) {
  this.containerID = containerID;
  this.$container = null;
  this.$form = null;
  this.confirmedSubmit = false;

  this.init();
}

OrderConfirm.prototype = $.extend({}, {
  constructor: 'OrderConfirm',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '#' + _this.containerID + ' .change-item', function () {
      _this.changeItem($(this).closest('.order-items__item'));
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .fill-date', function () {
      _this.fillDate($(this).closest('.order-items__fill-date-wrapper'));
      return false;
    });

    $('body').on('change', '#' + _this.containerID + ' .item__supplier-delivery-date', function () {
      _this.changeDeliveryDate($(this).closest('.order-items__item'));
      return false;
    });

    $('body').on('change', '#' + _this.containerID + ' .item__not-delivered', function () {
      _this.itemNotDelivered($(this).closest('.order-items__item'));
      return false;
    });

    $('body').on('change', '#' + _this.containerID + ' .item__price', function () {
      _this.changePriceTotal($(this).closest('.order-items__item'));
      return false;
    });

    $('body').on('submit', '#' + _this.containerID + ' form', function () {
      return _this.isAllowedSubmitForm();
    });
  },

  //----------------------------------------------------------------------------

  isValid: function isValid() {
    var _this = this;

    var ret = true;
    _this.$form.find('.order-items__item:not(.order-items__item--processed)').each(function () {
      var $row = $(this);

      var $notDelivered = $row.find('.item__not-delivered');
      var $date = $row.find('.item__supplier-delivery-date');

      if (isEmpty($date.val()) && !$notDelivered.is(':checked')) {
        ret = false;
      }
    });

    return ret;
  },

  isAllowedSubmitForm: function isAllowedSubmitForm() {
    var _this = this;

    if (!_this.confirmedSubmit && !_this.isValid()) {
      services.get('confirm-service').confirmHtml(services.get('translator').trans('purchase_order.invalid_form'), function (ret) {
        if (ret) {
          _this.confirmedSubmit = true;
          _this.$form.submit();
        }
      });

      return false;
    }

    return true;
  },

  getChangeItemForm: function getChangeItemForm(origQuantity, $row) {
    var _this = this;
    var $form = _this.$container.find('.change-item-form-wrapper').clone();

    $form.removeClass('hidden');
    $form.find('input[name="Quantity"]').val(origQuantity);
    $form.find('.unit').text($row.find('.unit').text());

    return $form;
  },

  changeItem: function changeItem($row) {
    var _this = this;

    var modal = services.get('modal');
    var translator = services.get('translator');

    var origQuantity = parseFloat($row.find('input[name^="Quantity"]').val());

    modal.empty().open({
      height: '150',
      width: 'sm',
      title: translator.trans('purchase_order.item.change_amount'),
      form: true,
      openCallBack: function () {
        modal.contentDOM().find('input:first').focus();
      },

      submitCallBack: function () {
        var $content = modal.contentDOM();
        $content.find('has-error').removeClass('has-error');

        var $input = $content.find('input[name="Quantity"]');
        var quantity = parseFloat($input.val().replace(',', '.'));

        if (!isEmpty(quantity)) {
          if (origQuantity >= quantity && quantity > 0) {
            $row.find('input[name^="Quantity"]').val(quantity);
            $row.find('.quantity').text(quantity);

            var newQuantity = origQuantity - quantity;
            if (newQuantity > 0) {
              var $dataContainer = _this.$container.find('.data-container');

              var $newRow = $row.clone();
              var newKey = parseInt($dataContainer.data('last_key')) + 1;
              $dataContainer.data('last_key', newKey);

              $newRow.find('input[name^="Quantity"]').val(newQuantity);
              $newRow.find('.quantity').text(newQuantity);
              $newRow.find('.item__supplier-delivery-date').removeAttr('disabled');
              $newRow.find('.item__not-delivered').prop('checked', false);
              $newRow.find('.clear-input').val('');
              $newRow.find('input').each(function () {
                replaceAttrKey($(this), 'name', 1, newKey);
              });

              $newRow.insertAfter($row);

              initialize($newRow);

              _this.changePriceTotal($row);
              _this.changePriceTotal($newRow);
            }

            modal.close();
          } else {
            $input.parent().addClass('has-error');
          }
        } else {
          $input.parent().addClass('has-error');
        }
      }
    }).content(_this.getChangeItemForm(origQuantity, $row));
  },

  doFillDate: function doFillDate(date, forceFill) {
    var _this = this;

    _this.$container.find('.item__supplier-delivery-date').each(function () {
      var $input = $(this);

      if (!$input.is(':disabled')) {
        if (forceFill || isEmpty($input.val())) {
          $input.val(date);
        }
      }
    });

    return _this;
  },

  fillDate: function fillDate($row) {
    var _this = this;

    var date = $row.find('.order-items__date').val();
    if (isEmpty(date)) {
      return;
    }

    var existsFilled = false;

    _this.$container.find('.item__supplier-delivery-date').each(function () {
      var $input = $(this);

      if (!$input.is(':disabled') && !isEmpty($input.val())) {
        existsFilled = true;
      }
    });

    if (existsFilled) {
      services.get('confirm-service').confirmHtml(services.get('translator').trans('purchase_order.date_already_filled'), function (ret) {
        _this.doFillDate(date, ret);
      });
    } else {
      _this.doFillDate(date, false);
    }
  },

  changeDeliveryDate: function ($row) {
    var $notDelivered = $row.find('.item__not-delivered');
    var date = $row.find('.item__supplier-delivery-date').val();

    if (!isEmpty(date)) {
      $notDelivered.prop('checked', false);
    }
  },

  itemNotDelivered: function itemNotDelivered($row) {
    var $notDelivered = $row.find('.item__not-delivered');
    var $date = $row.find('.item__supplier-delivery-date');

    if ($notDelivered.is(':checked')) {
      $date.val('');
      $date.attr('disabled', true);
    } else {
      $date.removeAttr('disabled');
    }
  },

  changePriceTotal: function changePriceTotal($row) {
    var _this = this;

    var price = parseFloatK2($row.find('.item__price').val());
    var quantity = parseFloatK2($row.find('.item__quantity').val());

    $row.find('.item__price-total').text(formatFloatK2(roundToDecimals(price * quantity, 2)));

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerID);
    _this.$form = _this.$container.find('form');
    _this.registerCallbacks();
  }
});
